module.exports = __webpack_public_path__ + "img/brad.095ccfcb.png";